import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator } from '../../validators';

export const DetermineWordGrammarSchema = z.object({
  languages: z
    .array(languageEnumValidator)
    .optional()
    .default([LanguageEnum.RU]),
  text: z.string().min(1, 'Text cannot be empty'),
});

export type IDetermineWordGrammarDto = z.infer<
  typeof DetermineWordGrammarSchema
>;
